/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarytitle1Inputs */

const en_summarytitle1 = /** @type {(inputs: Summarytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recap`)
};

const de_summarytitle1 = /** @type {(inputs: Summarytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückblick`)
};

/**
* | output |
* | --- |
* | "Recap" |
*
* @param {Summarytitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarytitle1 = /** @type {((inputs?: Summarytitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarytitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarytitle1(inputs)
	return de_summarytitle1(inputs)
});
export { summarytitle1 as "summaryTitle" }